import React from "react";
import { Minus, Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How do I start an insurance claim for hail or smash damage?",
  answer: "Starting a claim is simple. Visit our 'Start Your Quote' page to upload photos of the damage. We coordinate directly with all major insurance providers in Australia to ensure your caravan is restored to factory standards without the stress."
}, {
  question: "Can you upgrade my caravan to an off-grid lithium system?",
  answer: "Yes, we specialize in high-performance solar and lithium battery installations. Whether you need more capacity for appliances or complete off-grid independence, we can design a custom system. Check our 'Solar/Battery Systems' page for more details."
}, {
  question: "Are your technicians licensed for electrical and gas work?",
  answer: "Absolutely. Our South Windsor team includes fully licensed specialists for all 240V/12V electrical systems and gas plumbing. We ensure every installation, from air conditioners to kitchen appliances, meets strict Australian safety standards."
}, {
  question: "What is the typical turnaround time for major structural repairs?",
  answer: "Turnaround times vary based on the extent of the damage and parts availability. Most insurance repairs are completed within 2 to 4 weeks. We prioritize structural integrity and precision craftsmanship to get you back on the road safely."
}, {
  question: "Do you offer private repairs and general servicing?",
  answer: "While we specialize in smash and insurance work, we also provide comprehensive private repairs and motorhome servicing. From resealing leaks to chassis inspections, we maintain your caravan's value and performance for years of travel."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="17166" id="frequently-asked-questions" className="relative w-full overflow-hidden bg-background py-[120px]">
      {}
      <div className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div ref={ref} className={`relative z-10 mx-auto max-w-3xl px-4 transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        {}
        <div className="mb-12 text-center">
          <Badge variant="outline" className="mb-6 border-accent/50 bg-accent/10 px-3 py-1 text-sm font-mono uppercase tracking-widest text-accent backdrop-blur-md">
            Technical FAQ
          </Badge>
          <h2 className="text-3xl font-bold tracking-tighter text-primary md:text-4xl lg:text-5xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-muted-foreground">
            Expert answers on caravan repairs, solar installations, and insurance claims.
          </p>
        </div>

        {}
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none">
              <AccordionTrigger className="group flex w-full items-center justify-between rounded-xl bg-card px-6 py-5 text-left text-base font-bold text-primary shadow-sm transition-all duration-300 hover:bg-muted/50 hover:no-underline data-[state=open]:bg-muted/80 [&>svg:last-child]:hidden">
                <span className="mr-4">{faq.question}</span>
                <div className="relative flex size-5 shrink-0 items-center justify-center text-secondary">
                  <Plus className="absolute size-5 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                  <Minus className="absolute size-5 rotate-90 opacity-0 transition-transform duration-300 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-4 pt-2 text-muted-foreground">
                <div className="pt-2 leading-relaxed">{faq.answer}</div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}